import type { CustomerResponse } from "./types";

export const splitRepresentativeId = (representativeId?: string | null) => {
  const normalized = (representativeId || "").trim().toUpperCase();
  const [mtCode, ...branchParts] = normalized.split("-");
  return {
    representative_id: normalized,
    mt_code: mtCode,
    branch_code: branchParts.join("-"),
  };
};

export const buildCustomerCode = (
  customer: Pick<CustomerResponse, "mt_code" | "branch_code">,
): string =>
  [customer.mt_code.trim(), (customer.branch_code || "").trim()]
    .filter(Boolean)
    .join("-")
    .toUpperCase();

export const getCustomerDisplayName = (customer: CustomerResponse): string =>
  customer.company_out_name?.trim() ||
  customer.company_in_name?.trim() ||
  buildCustomerCode(customer);
